import React from 'react'
import { Route, Switch } from 'react-router'
import { ROUTES } from '../App'
import NotFound from "../pages/notFound/notFound.jsx";
import CampaignGuard from "../helpers/campaign/campaignGuard";

const ContentRouter = () => {

	return (
		<Switch>
			{ROUTES.map(route => {
				const { key, path, exact, component:Component } = route;
				return (
					<Route
						key={key}
						path={path}
						exact={exact}
						render={(props) => (
							<CampaignGuard>
								<Component {...props} />
							</CampaignGuard>
						)}
					/>
				)
			})}
		</Switch>
	)
}

export default ContentRouter